<template>
    <div class="providerSection">
        <v-breadcrumbs style="height: 20px; padding: 0" :items="breadcrumbItems">
            <template #item="{ item }">
                <span
                    :style="{ cursor: item.disabled ? 'default' : 'pointer', color: item.disabled ? 'gray' : '#00AAEE' }"
                    @click="navigateTo(item)"
                >{{ item.text }}</span>
            </template>
            <template #divider>
                <v-icon>{{ mdiChevronRight }}</v-icon>
            </template>
        </v-breadcrumbs>
        <h1 style="margin: 0 auto;">
            <v-icon
                v-if="screen_width > 390"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiBook }}
            </v-icon>
            <span>Ledgers</span>
        </h1>
        <v-card
            class="docInfoBody"
            elevation="10"
            style="margin: 2% auto 0 auto;"
        >
            <v-row>
                <v-col cols="8">
                    <v-autocomplete
                        v-model="msu_code"
                        clearable
                        autocomplete="nope"
                        :items="combinedItems"
                        label="Hospital or Clinic Name"
                        item-text="combinedText"
                        return-object
                        :search-input.sync="testVar"
                    >
                        <template #selection="data">
                            <p v-if="hospClinName.status" style="word-break: break-all; position: absolute; overflow-y: hidden; height: 37px; margin: 0 10px 2px 0; padding: 0 30px 0 0">
                                <v-chip class="white--text" color="teal darken-1" style="margin-right: 5px">
                                    {{ data.item.hosp_msu_code }}
                                </v-chip>{{ data.item.hosp_name }}
                            </p>
                        </template>
                        <template #item="data">
                            <p style="margin: 0 0 10px 0; padding: 10px 0 0 0; height: 40px;">
                                <v-chip class="white--text" color="teal darken-1" style="margin: 3px 5px 0 0;">
                                    {{ data.item.hosp_msu_code }}
                                </v-chip><span style="margin: 0; padding: 0">{{ data.item.hosp_name }}</span>
                            </p>
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-col cols="4">
                    <v-text-field
                        v-model="searchQuery"
                        label="Search"
                        color="teal"
                        clearable
                        :append-icon="mdiMagnify"
                        @keyup.enter="search = searchQuery"
                        @click:append="search = searchQuery"
                        @click:clear="search = ''"
                    />
                </v-col>
            </v-row>
            <v-spacer />
            <v-data-table
                style="width: 100%;"
                :dense="true"
                :headers="headers"
                :items="fetchListLedgersData && fetchListLedgersData.data ? fetchListLedgersData.data : []"
                :search="search"
            >
                <template #[`item.CNTRL_N`]="{ item }">
                    <v-chip dense style="font-weight: 600;">
                        {{ item.CNTRL_N }}
                    </v-chip>
                </template>
                <template #[`item.GEN_BY`]="{ item }">
                    <span style="text-wrap: nowrap">{{ item.GEN_BY }}</span>
                </template>
                <template #[`item.GEN_DATE`]="{ item }">
                    <span style="text-wrap: nowrap">{{ formatDate(item.GEN_DATE) }}</span>
                </template>
                <template #[`item.ACTIONS`]="{ item }">
                    <v-btn
                        :loading="loadingView && currentView.CNTRL_N == item.CNTRL_N"
                        style="min-width: 15px; padding: 15px; color: white"
                        color="teal"
                        @click="view(item)"
                    >
                        <v-icon>{{ mdiEye }}</v-icon>
                    </v-btn>
                    <v-btn
                        :loading="loading && currentDownload.CNTRL_N == item.CNTRL_N"
                        style="min-width: 15px; padding: 15px; color: white"
                        color="teal"
                        @click="download(item)"
                    >
                        <v-icon>{{ mdiDownload }}</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card>
        <CtrlLedgerDialog
            :show="showDialog"
            :current-view="currentView"
            @closeDialog="showDialog = false"
        />
    </div>
</template>

<script>
import CtrlLedgerDialog from './CtrlLedgerDialog.vue'
import { saveAs } from 'file-saver'
import { mapActions, mapGetters } from 'vuex'
import {
    mdiChevronRight,
    mdiBook,
    mdiEye,
    mdiDownload,
    mdiMagnify
} from '@mdi/js'
import { base64ToBlob } from '../../../utils/helpers'
import { moment } from '../../../utils/date-shim'
export default {
    components: {
        CtrlLedgerDialog
    },
    data: ()=>({
        mdiChevronRight,
        mdiBook,
        mdiEye,
        mdiDownload,
        mdiMagnify,
        hospClinName: {
            status: true,
            val: null
        },
        testVar: '',
        showDialog: false,
        search: null,
        searchQuery: null,
        headers: [
            { text: 'Control Number', value: 'CNTRL_N' },
            { text: 'MSU Code', value: 'MSU_N' },
            { text: 'MSU Name', value: 'hosp_name' },
            { text: 'Generated By', value: 'GEN_BY' },
            { text: 'Generated Date', value: 'GEN_DATE' },
            { text: 'Actions', value: 'ACTIONS' }
        ],
        loading: false,
        currentDownload: null,
        loadingView: false,
        currentView: null,
        screen_width: document.documentElement.clientWidth + 9,
        msu_code: null
    }),
    computed: {
        ...mapGetters(['fetchListLedgersData', 'downloadLedgerClaimsData', 'viewLedgerData', 'fetchProviderClaimsData']),
        breadcrumbItems() {
            return this.$route.matched.map(route => ({
                text: route.meta.breadcrumb,  // Get the breadcrumb label from meta
                disabled: route.path === this.$route.path,  // Disable the current route
                to: route.path  // Define the route to navigate
            }))
        },
        combinedItems() {
            if (!this.fetchProviderClaimsData || !this.fetchProviderClaimsData.data) return []
            return [{ hosp_name: 'ALL', hosp_msu_code: 'ALL', combinedText: 'ALL' }].concat(
                this.fetchProviderClaimsData.data.map(item => ({
                    ...item,
                    combinedText: `${item.hosp_msu_code} ${item.hosp_name}`
                }))
            )
        }
    },
    watch: {
        testVar(newVal) {
            if (newVal) {
                this.hospClinName.status = false
            } else {
                this.hospClinName.status = true
            }
        },
        searchQuery(newVal) {
            if (newVal === '' || newVal === null || newVal === undefined)
                this.search = ''
        },
        downloadLedgerClaimsData(newVal) {
            if (newVal && newVal.data) {
                this.loading = false
                this.handleFileDownload(newVal.data, `${this.currentDownload.CNTRL_N}.xlsx`)
            }
        },
        viewLedgerData(newVal) {
            if (newVal && newVal.data) {
                this.loadingView = false
                this.showDialog = true
            }
        },
        msu_code(newVal) {
            if (newVal) {
                this.hospClinName.status = true
                this.fetchListLedgers({ MSU_C: newVal.hosp_msu_code })
            }
        }
    },
    async mounted(){
        window.addEventListener('resize', this.onResize)
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    created() {
        this.fetchProvidersClaims().then(() => {
            this.msu_code = { hosp_name: 'ALL', hosp_msu_code: 'ALL', combinedText: 'ALL' }
            this.fetchListLedgers({ MSU_C: this.msu_code.hosp_msu_code })
        })
    },
    methods: {
        ...mapActions(['getCsrfToken', 'fetchListLedgers', 'downloadLedgerClaims', 'viewLedger', 'fetchProvidersClaims']),
        navigateTo(item) {
            if (!item.disabled) this.$router.push(item.to)  // Programmatic navigation using router.push
        },
        handleFileDownload(data, fileName) {
            try {
                const blob = base64ToBlob(data.file, data.type)
                saveAs(blob, fileName)
            } catch (error) {
                // console.error('handleFileDownload error: ', error)
            }
        },
        async view(item) {
            this.loadingView = true
            this.currentView = item
            // await this.getCsrfToken()
            if (item && item.CNTRL_N)
                this.viewLedger({ MSU_C: item.MSU_N, CNTRL_N: item.CNTRL_N })
        },
        async download(item) {
            this.loading = true
            this.currentDownload = item
            // await this.getCsrfToken()
            if (item && item.CNTRL_N)
                this.downloadLedgerClaims({ MSU_C: item.MSU_N, CNTRL_N: item.CNTRL_N })
        },
        formatDate(date) {
            return moment(date).format('MMMM D, YYYY')
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style scoped>
.v-input__append-inner {
    background-color: white;
}
h1 {
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
.docInfoBody {
    margin-top: 5%;
    padding: 3%;
}
.v-list-item {
    height: 10px;
}
@media (max-width: 380px) {
  .providerSection {
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (max-width: 599px) {
  .providerSection {
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (min-width: 599px) and (max-width: 1264px) {
  .providerSection {
    padding: 70px 7.5% 0 7.5%;
  }
}
@media (min-width: 1264px) {
  .providerSection {
    padding: 10px 7.5% 0 7.5%;
  }
}
</style>
